import { Component } from 'react';
import { connect } from 'react-redux';

// @ts-expect-error not typed

// @ts-expect-error not typed
import { getSecurityTypes } from '../selectors/DocSelectors';
import EndpointComp from '../../../components/endpoint/EndpointComp';
import { jsx as _jsx } from "react/jsx-runtime";
class PathUrl extends Component {
  render() {
    const {
      oas,
      operation
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "path-container",
      children: oas.servers && oas.servers.length > 0 && /*#__PURE__*/_jsx(EndpointComp, {
        method: operation.method,
        path: operation.path
      })
    });
  }
}
const select = (state, ownProps) => ({
  securityTypes: getSecurityTypes(state, ownProps).sort().reverse()
});
export default connect(select)(PathUrl);